import React from 'react';
import { useUser } from '../context/UserContext';
import logo from '../images/logo-app.png'; // ✅ Novo PNG transparente
import './Header.css';

const Header = () => {
  const { user, userData } = useUser();

  return (
    <header className="app-header">
      <div className="header-content">
        {/* ✅ Espaço para o Burger Menu (Left) */}
        <div className="header-menu-space"></div>

        {/* ✅ Logo PNG Centralizada */}
        <div className="header-logo">
          <img 
            src={logo}
            alt="Lotopim" 
            className="logo-image"
          />
        </div>

        {/* ✅ Olá, usuário (Right) - CORRIGIDO PARA MOBILE */}
        <div className="header-greeting">
          {user && (
            <span className="greeting-text">
              Olá, {userData?.name || user.email?.split('@')[0] || 'usuário'}
            </span>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;